import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
const styles = theme => ({
  container: {
    margin: "40px 0px",
    height: "auto",
    background: theme.palette.primary.white,
    padding: "65px 0px 25px 0px",
    boxShadow: "0 10px 20px 0 rgba(20,21,26,0.1)"
  }
});
class Card extends Component {
  render() {
    const { classes } = this.props;

    return <div className={classes.container}>{this.props.children}</div>;
  }
}
export default withStyles(styles)(Card);
